module.exports = __webpack_public_path__ + "static/media/ninx5.e6ba2f43.jpg";